export type FeaturesProps = {
  canAccessDeactivationRedesign: boolean;
  canAccessSpotlightListing: boolean;
  metroidIframeButtonText: string;
  pandaTheme: string;
};

export type ConfigProps = {
  features: FeaturesProps;
};

export type AppConfigProps = {
  config: ConfigProps;
};

const Features = ({
  canAccessDeactivationRedesign = false,
  canAccessSpotlightListing = false,
  metroidIframeButtonText = '',
  pandaTheme = '',
}: Partial<FeaturesProps> = {}): FeaturesProps => ({
  canAccessDeactivationRedesign: Boolean(canAccessDeactivationRedesign),
  canAccessSpotlightListing: Boolean(canAccessSpotlightListing),
  metroidIframeButtonText: String(metroidIframeButtonText),
  pandaTheme: String(pandaTheme),
});

const Config = ({ features }: Partial<ConfigProps> = {}): ConfigProps => ({
  features: Features(features),
});

// only expose config property
// keeping the data model the same structure as response
// in order to easily add other properties
const AppConfig = ({ config }: Partial<AppConfigProps> = {}): AppConfigProps => ({
  config: Config(config),
});

export { Features };

export default AppConfig;
